export default {
    CHANGE_QUESTION_MODEL_CONFIRM_DIALOG: {
        MESSAGE: 'Al cambiar el modelo de esta pregunta, se perderá cualquier información ya respondida a esta pregunta. Póngase en contacto con Enginehire si tiene alguna pregunta.',
        ACCEPT_LABEL: 'Continuar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_REFERENCE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta referencia?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_EXPERIENCE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta experiencia?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_CONTACT_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar este contacto?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_EDUCATION_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta educación?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar a este niño?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PET_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta mascota?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta reserva?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PROFILE_BUILDER_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar el creador de perfiles {0}?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta solicitud?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_JOB_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar este trabajo?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_APPLICATION_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta aplicación?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar el documento {0}?',
        ACCEPT_LABEL: 'Eliminar documento',
        REJECT_LABEL: 'Cerrar'
    },
    BULK_DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: '¿Está absolutamente seguro de que desea eliminar estos documentos?',
        ACCEPT_LABEL: 'Eliminar documentos',
        REJECT_LABEL: 'Cerrar'
    },
    DELETE_FILE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar el archivo?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cerrar'
    },
    DELETE_TEMPLATE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar la {0} plantilla {1}?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PRICE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar {0} {1}?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PHOTO_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar la foto {0}?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar la imagen?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_USER_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>¿Está seguro de que desea eliminar este usuario?</h3>
        <p>{0} {1}</p>
        <p>{2}</p>`,
        ACCEPT_LABEL: "Borrar",
        REJECT_LABEL: "Cancelar"
    },
    DELETE_ADMIN_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>¿Está seguro de que desea eliminar este usuario?</h3>
        <p>{0}</p>`,
        ACCEPT_LABEL: "Borrar",
        REJECT_LABEL: "Cancelar"
    },
    DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar {0}?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    CANCEL_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea cancelar esta reserva?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    CANCEL_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea cerrar? Cualquier cambio se perderá.',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea aceptar el trabajo {0}?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    DECLINE_JOB_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea rechazar el trabajo {0}?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    EDIT_CONFIRM_DIALOG: {
        MESSAGE: '¿Estás seguro de tus cambios?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    BULK_UPDATE_LOCATIONS_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea cambiar las ubicaciones de los {0} usuarios seleccionados? Sus ubicaciones se cambiarán a {1}.',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    BULK_STATUS_CHANGE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea cambiar el estado de los {0} usuarios seleccionados? Su estado cambiará a {1}.',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    OVERWRITE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'Hay un video grabado. Si graba un video nuevo, el video existente se sobrescribirá. ¿Estás seguro de continuar?',
        ACCEPT_LABEL: 'Continuar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PROFILE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: '¿Estás seguro de que quieres eliminar la foto de perfil?',
        ACCEPT_LABEL: 'Borrar imagen',
        REJECT_LABEL: 'Cerrar'
    },
    DELETE_RELATIONSHIP_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar el enlace entre {0} y este cliente?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    CANDIDATE_ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Te comprometes a ocupar este puesto, ¿estás seguro?',
        ACCEPT_LABEL: 'Aceptar trabajo',
        REJECT_LABEL: 'Cerrar'
    },
    MARK_AS_FAVORITE_CONFIRM_DIALOG: {
        MESSAGE: '¿Estás seguro de que quieres marcar a {0} como favorito?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    MARK_AS_DO_NO_WANT_CONFIRM_DIALOG: {
        MESSAGE: '¿Estás seguro de que no quieres volver a {0}?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    DELETE_NOTE_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>¿Está seguro de que desea eliminar la nota?</h3>
        <p style="espacio en blanco: ajuste previo;">{0}</p>`,
        ACCEPT_LABEL: "Borrar",
        REJECT_LABEL: "Cancelar"
    },
    DELETE_CREDIT_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar este crédito?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_MULTI_ITEMS_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea eliminar los {0} {1} seleccionados?",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    UNASSIGN_JOBS_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea anular la asignación de {0} trabajos seleccionados? Su estado se pondrá en "{1}".',
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    BULK_CHANGE_JOB_STATUS_CONFIMR_DIALOG: {
        MESSAGE: "¿Está seguro de que desea cambiar el estado de los {0} trabajos seleccionados? Su estado cambiará a {1}.",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    BULK_ASSIGN_CANDIDIATES_TO_MULTIPLE_JOBS_DIALOG: {
        MESSAGE: "¿Está seguro de que desea asignar {0} trabajos seleccionados al candidato seleccionado?",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    PACKAGE_SELECTION_CONFIRMACIÓN: {
        INNER_HTML: `<h2>Confirmar selección - {0}</h2>
        <hr />
        <h5>
          He leído y confío en los términos y condiciones con el
          paquete elegido.
        </h5>`,
        ACCEPT_LABEL: "Confirmar selección",
        REJECT_LABEL: "Cancelar"
    },
    DELETE_EVALUATION_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta evaluación?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_QUESTION_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta pregunta?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_OPTION_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta opción?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    POST_WEEK_DISPONIBILIDAD_CONFIRMACIÓN_DIÁLOGO: {
        MESSAGE: '¿Está seguro de la disponibilidad que ha introducido?',
        ACCEPT_LABEL: 'Confirmar disponibilidad',
        REJECT_LABEL: 'Espera, déjame comprobar de nuevo'
    },
    TIME_OFF_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de su solicitud?',
        ACCEPT_LABEL: 'Enviar solicitud',
        REJECT_LABEL: 'Solicitud de edición'
    },
    REMOVE_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: '{0} ({1}) - Eliminar disponibilidad',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_WEEK_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar la disponibilidad semanal?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    RESET_WEEK_DISPONIBILIDAD: {
        MESSAGE: '¿Está seguro de que desea restablecer la disponibilidad semanal?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    SUBMIT_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de su solicitud?",
        ACCEPT_LABEL: "Enviar solicitud",
        REJECT_LABEL: "Solicitud de edición"
    },
    DELETE_TIME_OFF_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea eliminar el tiempo libre?",
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    MARK_ALL_AS_PUBLIC_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea marcar todos los {0} como públicos (visibles para todos)?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    BROADCAST_SMS_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea enviar SMS a {0} usuarios",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    CREATE_JOB_CONFIRM_DIALOG: {
        INNER_HTML: '<h4>Crear trabajo</h4>'
            + '<hr>' +
            '<h5>Si está comenzando un trabajo, pero no figura en su horario, utilice esta opción.' +
            ' Esto creará un nuevo trabajo en el que podrá marcar la entrada y la salida, y completaremos los demás detalles más adelante.' +
            ' Al registrarte, ten en cuenta para qué familia trabajas y cualquier otra cosa que debamos saber.</h5>',
        ACCEPT_LABEL: 'Crear trabajo',
        REJECT_LABEL: 'Cancelar'
    },
    ASSIGN_TO_NO_MATCH_CANDIDATE: {
        MESSAGE: "Existe una relación 'No coincide' entre cliente y candidato. ¿Está seguro de que desea asignar la reserva a este candidato?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    ASSIGN_TO_UNAVAILABLE_CANDIDATE: {
        MESSAGE: "El candidato no está disponible. ¿Está seguro de que desea asignar la reserva a este candidato?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    ASSIGN_TO_ALREADY_BOOKED_CANDIDATE: {
        MESSAGE: "El candidato ya está reservado en este momento. ¿Está seguro de que desea asignar la reserva a este candidato?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    ASSIGN_TO_TIME_OFF_CANDIDATE: {
        MESSAGE: "El candidato tiene tiempo libre en este momento. ¿Está seguro de que desea asignar la reserva a este candidato?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    RELEASE_SCHEDULE_CONFIRM_DIALOG: {
        MESSAGE: "¿Estás listo para publicar el horario?",
        ACCEPT_LABEL: 'Calendario de lanzamiento',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_BOOKING_GROUP_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea eliminar el grupo de reserva?",
    },
    ACCEPT_BOOKING_IN_GROUP_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>La reserva pertenece a un grupo. ¿Está seguro de que desea aceptar todas las reservas de ese grupo?</h3>
        <ul>{0}</ul>`,
        ACCEPT_LABEL: "Aceptar todo",
        REJECT_LABEL: "Cancelar"
    },
    UPDATE_JOB_POSTER_CONFRM_DIALOG: {
        MESSAGE: "¿Desea actualizar los campos de dirección de acuerdo con el nuevo anuncio de trabajo?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    CLIENT_CONFIRM_CLOCK_IN_OUT_MESSAGE: {
        INNER_HTML: "<h3>¿Está seguro de que desea aprobar la hora de entrada y salida del candidato</h3>" +
            "<ul><li>Hora de entrada: {0}</li><li>Hora de salida: {1}</li></ul>",
        ACCEPT_LABEL: 'Aprobar',
        REJECT_LABEL: 'Cancelar'
    },
    SELECT_CREDIT_PACKAGE_CONFIRM_DIALOG: {
        MESSAGE: "Se le cobrará {0}{1} por {2} créditos. ¿Está seguro de que desea continuar?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    UNASSIGN_CANDIDATE_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea cancelar la asignación de este candidato?",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    UPDATE_RATE_BASED_ON_BOOKING_SERVICE_CONFIRM_DIALOG: {
        MESSAGE: "¿Desea actualizar la tarifa del cliente y la tarifa del candidato en consecuencia?",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    DELETE_BREAK_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea eliminar este descanso?",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    BULK_CHARGE_CLIENT_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>¿Está seguro de que desea cobrar a los clientes por los siguientes trabajos?</h3>
        <ul>{0}</ul>`,
        ACCEPT_LABEL: "Cargo",
        REJECT_LABEL: "Cancelar"
    },
    BULK_INVOICE_STRIPE_CLIENT_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>¿Está seguro de que desea enviar la factura a los clientes a través de Stripe para los siguientes trabajos?</h3>
        <ul>{0}</ul>`,
        ACCEPT_LABEL: "Enviar Factura",
        REJECT_LABEL: "Cancelar"
    },
    BULK_CHARGE_PAYOUT_STRIPE_CONFIRM_DIALOG: {
        INNER_HTML: `<h3>¿Está seguro de que desea cobrar a los clientes y pagar a los candidatos a través de Stripe para los siguientes trabajos?</h3>
        <ul>{0}</ul>`,
        ACCEPT_LABEL: "Transferir",
        REJECT_LABEL: "Cancelar"
    }
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/confirm-dialog/es.js